import React, { useEffect } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import { Autenticacao } from "../pages/Autenticacao";
import { Recomendacao } from "../pages/Recomendacao";
import { CarrosselPreview } from "../pages/Recomendacao/CarrosselPreview";
import { Filtros } from "../pages/Recomendacao/Filtros";
import { Lojas } from "../pages/Recomendacao/Lojas";
import { Pesquisa } from "../pages/Recomendacao/Pesquisa";
import { VerMais } from "../pages/Recomendacao/VerMais";
import { Descricao } from "../pages/Recomendacao/Descricao";
import { useLocation } from "react-router-dom";
import { useSession } from "../context/useSession";
import { useFirebase } from "../context/useFirebase";
import { formataEventosDeTela } from "../utils";

const RoutesListener = () => {
  const { session } = useSession();
  const { firebase, analyticsEvent } = useFirebase();
  const location = useLocation();

  useEffect(() => {
    if (window.location.pathname !== "/autenticacao" && firebase) {
      analyticsEvent(formataEventosDeTela(window.location.pathname), {screen: location.pathname})
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, session, firebase]);

  return <></>;
};

const Routes = () => {
  return (
    <BrowserRouter>
      <RoutesListener />
      <Switch>
        <Route exact path="/autenticacao" component={Autenticacao} />
        <Route exact path="/" component={Recomendacao} />
        <Route exact path="/carrosselpreview" component={CarrosselPreview} />
        <Route exact path="/filtros" component={Filtros} />
        <Route exact path="/lojas" component={Lojas} />
        <Route
          exact
          path="/vermais/:nomerecomendacao/:idtiporecomendacao"
          component={VerMais}
        />
        <Route exact path="/pesquisa" component={Pesquisa} />
        <Route
          exact
          path="/descricao/:idtiporecomendacao/:idoferta"
          component={Descricao}
        />
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
